import React from 'react'
import styled from 'styled-components'
import { giphyDarkestGrey, giphyLightGrey } from '@giphy/js-brand'
import { privacyTermsIndex } from 'shared/css/z-indexes'

const FloatingLinks = () => {
    return (
        <Container>
            <SingleLink href="/privacy">Privacy</SingleLink>
            <SingleLink href="/terms">Terms</SingleLink>
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    position: fixed;
    bottom: 10px;
    right: 10px;
    z-index: ${privacyTermsIndex};
`

const SingleLink = styled.a`
    color: ${giphyLightGrey};
    margin-right: 10px;
    border-radius: 5px;
    background: ${giphyDarkestGrey};
    padding: 6px;
    &:hover {
        color: white;
    }
`

export default FloatingLinks
